// Today narrowed to tags (Bastian, 2026-11-04): a row of the tags Today's to-dos carry; a click picks one, more can be
// picked, and Today keeps the to-dos with any of them. Not stored: it holds while the page is open. The kit's
// TagFilter.swift is the reference; cases/lists.json ("todayTags", "today#…") checks both.

import type { ListSection } from "./lists";

/** The order of localizedStandardCompare: by the user's language, numbers by their value ("Tag 2" before "Tag 10"). */
const order = (a: string, b: string) => a.localeCompare(b, undefined, { numeric: true });

/**
 * The tags to offer: those the to-dos shown carry (their own, not their project's or area's), A to Z, and those picked
 * that no to-do shown carries any more (the last one ticked), so they can still be let go.
 */
export function tagsIn(sections: readonly ListSection[], picked: ReadonlySet<string> = new Set()): string[] {
  const tags = new Set<string>(picked);
  for (const section of sections) for (const todo of section.todos) for (const tag of todo.tags) tags.add(tag);
  return [...tags].sort(order);
}

/**
 * The sections with only the to-dos that carry any picked tag; a section left without a to-do steps aside, as do the
 * projects a list shows between them. Nothing picked: the sections as they are.
 */
export function applyTagFilter(picked: ReadonlySet<string>, sections: ListSection[]): ListSection[] {
  if (picked.size === 0) return sections;
  return sections.flatMap((section) => {
    const todos = section.todos.filter((todo) => todo.tags.some((tag) => picked.has(tag)));
    return todos.length === 0 ? [] : [{ ...section, todos, projects: [] }];
  });
}
